import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faChevronLeft, faChevronRight, faCopy, faFilter, faFilterCircleXmark, faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { apiService } from '../../../services/apiService';
import Box from '@mui/material/Box';
import { MenuItem, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TaskTabs from '../../../components/common/TaskTabs';
import dayjs from 'dayjs';
import { Modal } from 'react-bootstrap';
import { faCircleDown } from '@fortawesome/free-regular-svg-icons';
import ExportDialogs from '../../../components/exporttable/ExportDialogs';
import { useTableExport } from '../../../components/exporttable/useTableExport';

function GroupTask() {
    const navigate = useNavigate();

    // 🔹 session storage helpers
    const SS_PREFIX = 'groupTask_';
    const getStored = (key, fallback) => {
        try {
            const v = sessionStorage.getItem(SS_PREFIX + key); 
            return v !== null ? JSON.parse(v) : fallback;
        } catch {
            return fallback;
        }
    };

    const [myrequests, setMyRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingApply, setLoadingApply] = useState(false);
    const [selectedCase, setSelectCase] = useState(() => getStored('selectedCase', "general"));
    const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => getStored('columnVisibility', {}));

    const [searchQuery, setSearchQuery] = useState(() => getStored('searchQuery', ""));
    const [searchQueryApi, setSearchQueryApi] = useState(() => getStored('searchQueryApi', ""));
    // Tableview with filter
        const [paginatedata, setPaginateData] = useState({});
        const [currentPage, setCurrentPage] = useState(1);
        const [selectedRecord, setShowRecord] = useState(20);
        const [loadingPage, setLoadingPage] = useState(false);
        const [isGridVisible, setGridVisible] = useState(false);
        const [applyFilData, setApplyfilData] = useState(() => getStored('applyFilData', []))

        const fetchRoots = useCallback(async (params = {}) => {
            setLoadingApply(true);
            try {
                const defaultParams = {
                    filter: "group_tasks",
                    case_type: selectedCase,
                    per_page: params?.per_page ?? selectedRecord,
                    search: searchQueryApi,
                    filters: params?.filters ?? applyFilData,  // 👈 always keep filters
                    ...params,
                };
                const response = await apiService.postRequest(`/my-tasks`, defaultParams);
                if(response.success === true){
                    setMyRequests(response.data);
                    setPaginateData(response.meta);
                    setShowRecord(response.meta?.per_page)
                }else{
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } catch (error) {
                console.error('Error fetching tab data:', error);
            } finally {
                setLoading(false);
                setLoadingApply(false);
                setLoadingPage(false);
            }
        }, [selectedCase, selectedRecord, applyFilData, searchQueryApi]);

        const handleSearchTable = () => {
            setApplyfilData(filters);
            fetchRoots({ filters });
            setCurrentPage(1);
        };
        const handleSearch = () => {
            setSearchQueryApi(searchQuery);
            setCurrentPage(1);
        };
        const handlePageChange = (newPage) => {
            setCurrentPage(newPage);
            fetchRoots({ page: newPage, filters: applyFilData });
            setLoadingPage(true);
        };

        useEffect(() => {
            fetchRoots();
        }, [fetchRoots]);


    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };

    const [filters, setFilters] = useState(() => getStored('filters', [{ logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]));

    // 🔹 persist filter / search / column / case state to session storage
    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'columnVisibility', JSON.stringify(columnVisibilityModel));
    }, [columnVisibilityModel]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'searchQuery', JSON.stringify(searchQuery));
    }, [searchQuery]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'searchQueryApi', JSON.stringify(searchQueryApi));
    }, [searchQueryApi]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'applyFilData', JSON.stringify(applyFilData));
    }, [applyFilData]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'selectedCase', JSON.stringify(selectedCase));
    }, [selectedCase]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'filters', JSON.stringify(filters));
    }, [filters]);


    const combineOptions = [
        { value: 'and', label: 'And' },
        { value: 'or', label: 'Or' },
    ];

    const rows = myrequests.map((datas) => ({
        id: datas.id,
        formatid: datas.format_id,
        subStage:datas.sub_stage,
        catalogItem: datas.catalog_item,
        stage: datas.stage,
        caseId: datas.case_id,
        requestedFor : datas.requested_for,
        requestedBy : datas.requested_by,
        assGroup:datas.assignment_group,
        assignTo:datas.assignment_to,
        requestType: datas.user_request_type,
        type: datas.type,
        status: datas.status,
        duedate: datas.due_date,
        createdOn: datas.created_at,
        uploadOn: datas.created_at,
        updateOn: datas.updated_at,
        onboardSlug: datas.onboarding_slug,
        onboardUserId: datas.onboarding_user_id,
        onboardJobseekId: datas?.jobseeker?.id,
        GeneralCase: datas?.general_case,
        gCaseDescription: datas?.gcase_summary?.short_description,
    }));
    const columnFieldToCSVKey = {
        formatid: 'ID',
        caseId: 'Case ID',
        catalogItem: 'Catalog Item',
        stage: 'Stage',
        subStage: 'Sub Stage',
        gCaseDescription: 'Short Description',
        requestedBy: 'Requested By',
        requestedFor: 'Requested For',
        assGroup: 'Assignment Group',
        assignTo: 'Assigned To',
        status: 'Status',
        duedate: 'Due Date',
        createdOn: 'Created On',
        updateOn: 'Updated On',
    };

    const getVisibleRowData = (row) => {
        const fullRow = {
            'ID': row.format_id,
            'Case ID': row.case_id,
            'Catalog Item': row.catalog_item,
            'Stage': row.stage,
            'Sub Stage': row.sub_stage,
            ...(selectedCase !== 'onboarding' && {
                'Short Description': row?.gcase_summary?.short_description,
            }),
            'Requested By': row.requested_by,
            'Requested For': row.requested_for,
            'Assignment Group': row.assignment_group,
            'Assigned To': row.assignment_to,
            'Status': row.status,
            'Due Date': row.due_date,
            'Created On': row.created_at,
            'Updated On': row.updated_at,
        };

        // Filter out hidden columns
        const visibleCSVKeys = Object.entries(columnFieldToCSVKey)
            .filter(([field]) => columnVisibilityModel[field] !== false)
            .map(([, csvKey]) => csvKey);

        return Object.fromEntries(
            Object.entries(fullRow).filter(([key]) => visibleCSVKeys.includes(key))
        );
    };

    // 🔹 Build the body for the server-side export endpoint.
    //    Uses the *applied* search/filters (not the unsaved inputs).
    const buildExportParams = () => ({
        filter: 'group_tasks',    // same value fetchRoots sends for this page
        case_type: selectedCase,
        search: searchQueryApi,
        filters: applyFilData,
    });

    // 🔹 Reusable export logic: pulls the FULL filtered dataset from
    //    /my-tasks/export, then downloads CSV or copies to clipboard.
    //    Handles the >10k email prompt and the background-running modal.
    const {
        exporting,
        prompt,
        requestExport,
        confirmEmail,
        confirmContinue,
        cancelPrompt,
    } = useTableExport({
        endpoint: '/my-tasks/export',
        endpointMail: '/send-mail-once-exported-the-tasks',
        mailFileBase: 'group_tasks_export',
        mapRow: getVisibleRowData,   // respects hidden columns
        fileName: 'group_tasks.csv',
    });

    const downloadCSV = () =>
        requestExport('download', {
            totalCount: paginatedata?.total ?? 0,
            params: buildExportParams(),
        });

    const copyToClipboard = () =>
        requestExport('copy', {
            totalCount: paginatedata?.total ?? 0,
            params: buildExportParams(),
        });

    const handleFilterChange = (index, field, value) => {
        const updated = [...filters];
        if (field === "column") {
            updated[index][field] = value;
            // Set default operator to "range" when column is created_on
            if (value === "created_on" || value === "due_date" || value === "updated_on") {
                updated[index].operator = "range";
                updated[index].value = "today";
            } else {
                updated[index].operator = "contains";
                updated[index].value = "";
            }
            delete updated[index].start_date;
            delete updated[index].end_date;
        } else if (field === "value") {
            updated[index].value = value;
            if (value !== "custom") {
                delete updated[index].start_date;
                delete updated[index].end_date;
            }
        } else {
            updated[index][field] = value;
        }

        setFilters(updated);
    };

    const addFilter = () => {
        setFilters([...filters, { logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]);
    };

    const removeFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };

    const operatorOptions = [
        { value: 'contains', label: 'Contains' },
        { value: 'does_not_contain', label: 'Does Not Contain' },
        { value: 'starts_with', label: 'Starts With' },
        { value: 'ends_with', label: 'Ends With' },
        { value: 'is', label: 'Is' },
        { value: 'is_not', label: 'Is Not' },
        { value: 'is_empty', label: 'Is Empty' },
        { value: 'is_not_empty', label: 'Is Not Empty' },
    ];
    const getOperatorOptions = (column) => {
        if (column === 'created_on' || column === "due_date" || column === "updated_on") {
            return [
                { value: 'range', label: 'Range' },
            ];
        }
        return operatorOptions; // Default options
    };
    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState(null);

    const handleClose = () => setShow(false);

    const handleShow = (data) => {
        setModalData(data);
        setShow(true);
    };
    const columns = [
        {
            field: 'formatid',
            headerName: 'ID',
            width: 200,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {params.row.type === "case_management" ?
                        <Link className='link_datatspan' to={`${params.row.GeneralCase.link}`} >
                            {params.row.formatid}
                        </Link>:
                    <Link className='link_datatspan'
                        to={
                            params.row.requestType === "correct_my_profile" && params.row.type === "user_request" ?
                                `/task/my_request_profile/${params.row.onboardJobseekId}/${params.row.id}` :
                            params.row.requestType === "report_technical_issue" && params.row.type === "user_request" ?
                                `/task/view-tech-issue/${params.row.onboardJobseekId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "i94-validation" ?
                                `/task/i94-validation/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "verify-member-details" ?
                                `/task/verify-member-details/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "member-confirmation" ?
                                `/task/member-confirmation/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "referral-investigation" ?
                                `/task/referral-investigation/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "engagement-overview" ?
                                `/task/engagement-overview/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "jobseeker-classification" ?
                                `/task/jobseeker-classification/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "setup-servicenow-interview" ?
                                `/task/setup-servicenow-interview/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "servicenow-interview-evaluation" ?
                                `/task/servicenow-interview-evaluation/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "past-payment-health-approval" ?
                                `/task/past-payment-health-approval/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "application-final-review" ?
                                `/task/application-final-review/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "placement-agreement" ?
                                `/task/placement-agreement/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "communication-eligibility" ?
                                `/task/communication-eligibility/${params.row.onboardUserId}/${params.row.id}` :
                            params.row.requestType === null && params.row.type === "onboarding" && params.row.onboardSlug === "admission-fees-payment" ?
                                `/task/admission-fees-payment/${params.row.onboardUserId}/${params.row.id}` :
                                '/task/my-request'
                            }
                    >
                        {params.row.formatid}
                    </Link>}
                </div>
            ),
            filterable: true
        },
        {
            field: 'caseId',
            headerName: 'Case ID',
            width: 200,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.caseId}</span>
                </div>
            ),
        },
        {
            field: 'catalogItem',
            headerName: 'Catalog Item',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.catalogItem}</span>
                </div>
            ),
        },
        {
            field: 'stage',
            headerName: 'Stage',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.stage}</span>
                </div>
            ),
        },
        {
            field: 'subStage',
            headerName: 'Sub Stage',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.subStage}</span>
                </div>
            ),
        },
        ...((selectedCase !== 'onboarding')
        ? [{
            field: 'gCaseDescription',
            headerName: 'Short Description',
            width: 300,
            filterable: true,
            renderCell: (params) => (
            <div className='d-flex align-items-center h-100'>
                {params.row.gCaseDescription !== "N/A" ?
                <button className='hisconten_view_btn' onClick={() => handleShow(params.row.gCaseDescription || 'N/A')}>View</button>:
                <span>{params.row.gCaseDescription}</span>}
            </div>
            ),
        }]
        : []),
        {
            field: 'requestedBy',
            headerName: 'Requested By',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.requestedBy}</span>
                </div>
            ),
        },
        {
            field: 'requestedFor',
            headerName: 'Requested For',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.requestedFor}</span>
                </div>
            ),
        },
        {
            field: 'assGroup',
            headerName: 'Assignment Group',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.assGroup}</span>
                </div>
            ),
        },
        {
            field: 'assignTo',
            headerName: 'Assigned To',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.assignTo}</span>
                </div>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span className={params.row.status === "Pending" ? "stautuspending" : params.row.status === "Closed" ? "stautusclosed" : "stautusprocess"}>{params.row.status}</span>
                </div>
            )
        },
        {
            field: 'duedate',
            headerName: 'Due Date',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.duedate}</span>
                </div>
            )
        },
        {
            field: 'createdOn',
            headerName: 'Created On',
            width: 200,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.createdOn}</span>
                </div>
            )
        },
        {
            field: 'updateOn',
            headerName: 'Update On',
            width: 200,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.updateOn}</span>
                </div>
            )
        },
    ];
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                    <Grid size={{md:6,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Task</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Task <FontAwesomeIcon className='angleright' icon={faAngleRight} /> My Task</span>
                    </Grid>
                    <Grid size={{md:6,xs:12}} container flexDirection="column" alignContent="flex-end" className="jobseekerhead">
                        <div className="d-flex jobseekersearch my-lg-3" style={{ position: "relative" }}>
                            <div className="col-md-9 input_jobssearch">
                                <FontAwesomeIcon className="iconcol" icon={faMagnifyingGlass} />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e)=> setSearchQuery(e.target.value)}
                                />
                                <button onClick={()=>{setSearchQuery("");setSearchQueryApi("");setCurrentPage(1);}} disabled={!searchQuery} class="close_marksearch">
                                    <FontAwesomeIcon className='px-2' icon={faXmark}/>
                                </button>
                            </div>
                            <div className="col-3">
                                <button
                                onClick={handleSearch}
                                >Search</button>
                            </div>
                        </div>
                    </Grid>
                    <Grid size={{md:12,xs:12}} container justifyContent="space-between" className="statusselectbtn my-4">
                        <Grid size={{sm:12,xs:12}} container>
                            <TaskTabs/>
                        </Grid>
                    </Grid>
                </Grid>

                <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                    {isGridVisible && (
                    <Box sx={{ mb: 2 }} className="my-4">
                        {filters.map((filter, index) => (
                            <Box key={index} className="d-flex align-items-start flex-wrap">
                                {index > 0 && (
                                    <select
                                        label="Combine"
                                        value={filter.logic}
                                        onChange={(e) => handleFilterChange(index, 'logic', e.target.value)}
                                        sx={{ mr: 1, minWidth: 80,mb:1 }}
                                    >
                                        {combineOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                )}
                                <TextField
                                    select
                                    label="Column"
                                    value={filter.column}
                                    onChange={(e) => handleFilterChange(index, 'column', e.target.value)}
                                    sx={{ mr: 1, minWidth: 120,mb:1 }}
                                >
                                    <MenuItem value="formatted_id">ID</MenuItem>
                                    <MenuItem value="case_id">Case Id</MenuItem>
                                    <MenuItem value="requested_by">Requested By</MenuItem>
                                    <MenuItem value="requested_for">Requested For</MenuItem>
                                    <MenuItem value="status">Status</MenuItem>
                                    <MenuItem value="stage">Stage</MenuItem>
                                    <MenuItem value="sub_stage">Sub Stage</MenuItem>
                                    {selectedCase === "general" &&
                                        <MenuItem value="short_description">Short Description</MenuItem>
                                    }
                                    <MenuItem value="assignment_group">Assignment Group</MenuItem>
                                    <MenuItem value="assigned_to">Assigned To</MenuItem>
                                    <MenuItem value="due_date">Due Date</MenuItem>
                                    <MenuItem value="created_on">Created On</MenuItem>
                                    <MenuItem value="updated_on">Updated On</MenuItem>
                                </TextField>
                                <TextField
                                    select
                                    label="Operator"
                                    value={filter.operator}
                                    onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                                    sx={{ mr: 1, minWidth: 120,mb:1 }}
                                >
                                    {getOperatorOptions(filter.column).map((option) => (
                                        <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                    ))}
                                </TextField>
                                {filter.operator === "is_not_empty" || filter.operator === "is_empty" ? "" :<>
                                    {filter.column === 'status' ? (
                                        <select
                                            label="Value"
                                            value={filter.value}
                                            onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                            sx={{ mr: 1, minWidth: 120,mb:1 }}
                                        >
                                            <option value="" disabled>Select Status</option>
                                            <option value="In-progress">In-progress</option>
                                            <option value="Completed">Completed</option>
                                            <option value="New">New</option>
                                            <option value="Rejected">Rejected</option>
                                            {selectedCase !== "general" &&<>
                                            <option value="hold">Hold</option>
                                            <option value="suspend">Suspend</option></>}
                                        </select>
                                    ) : (filter.column === 'created_on' || filter.column === "due_date" || filter.column === "updated_on") ? (
                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                            <TextField
                                                select
                                                label="Value"
                                                value={filter.value || "today"}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                sx={{ minWidth: 120,mb:1 }}
                                            >
                                                <MenuItem value="today">Today</MenuItem>
                                                <MenuItem value="yesterday">Yesterday</MenuItem>
                                                <MenuItem value="this_week">This Week</MenuItem>
                                                <MenuItem value="last_week">Last Week</MenuItem>
                                                <MenuItem value="this_month">This Month</MenuItem>
                                                <MenuItem value="last_month">Last Month</MenuItem>
                                                <MenuItem value="last_3_months">Last 3 Months</MenuItem>
                                                <MenuItem value="custom">Custom</MenuItem>
                                            </TextField>
                                            {filter.value === "custom" &&
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className="filterrages mb-2"
                                                    label="Start Date"
                                                    value={filter.start_date ? dayjs(filter.start_date) : null}
                                                    onChange={(newValue) =>
                                                        handleFilterChange(
                                                        index,
                                                        "start_date",
                                                        newValue ? newValue.format("YYYY-MM-DD") : null
                                                        )
                                                    }
                                                    />

                                                    <DatePicker
                                                    label="End Date"
                                                    className="filterrages mb-2 me-2"
                                                    value={filter.end_date ? dayjs(filter.end_date) : null}
                                                    onChange={(newValue) =>
                                                        handleFilterChange(
                                                        index,
                                                        "end_date",
                                                        newValue ? newValue.format("YYYY-MM-DD") : null
                                                        )
                                                    }
                                                    />
                                            </LocalizationProvider>}
                                        </Box>
                                    ) :(
                                        <input
                                            className='value_inputfilter mb-2'
                                            placeholder='Value'
                                            label="Value"
                                            value={filter.value}
                                            onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                        />
                                    )}</>}
                                <button className='filterremovebtn mb-2 ms-1' onClick={() => removeFilter(index)}>Remove</button>
                            </Box>
                        ))}
                        <button className='registersendbtn1 mt-2 mb-0' onClick={addFilter}>Add Filter</button>
                        <button className='registersendbtn2 mt-2 mb-0 ms-3' onClick={handleSearchTable}>
                            {loadingApply ? <img src={require('../../../assets/whiteloader.gif')} alt=''/> : 'Apply'}
                        </button>
                    </Box>
                )}
                    <Grid size={{xs:12}} container justifyContent="space-between">
                        <button className='show_filterbtn' onClick={toggleGrid}>
                            {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                        </button>
                        <div className='d-flex gap-3'>
                            <button className='download_csvbtndatatable' onClick={copyToClipboard}>Copy Table <FontAwesomeIcon className='ps-2' icon={faCopy} /></button>
                            <button className='download_csvbtndatatable' onClick={downloadCSV}>Download CSV<FontAwesomeIcon className='ps-2' icon={faCircleDown} /></button>
                            <select className='pink_rownded_select ' value={selectedCase}
                                onChange={(e) => {setSelectCase(e.target.value);
                                setLoading(true);
                                setCurrentPage(1);
                                setApplyfilData([])
                                setFilters([{ logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }])}}
                                >
                                <option value="general">General Case</option>
                                <option value="onboarding">Onboarding Case</option>
                            </select>
                        </div>
                    </Grid>
                    {loading ?
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        {(myrequests && myrequests.length === 0) ?
                        <span className='w-100 d-flex justify-content-center text-center'>No Data</span> :<>
                            {loadingPage ?
                                <div className='d-flex justify-content-center w-100'>
                                    <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                                </div> :<>
                                    <DataGrid
                                        style={{ minHeight: "200px" }}
                                        rows={rows}
                                        columns={columns}
                                        disableSelectionOnClick
                                        components={{ Toolbar: GridToolbar }}
                                        columnVisibilityModel={columnVisibilityModel}
                                        onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
                                    />
                                </>}
                            <Grid size={{xs:12}} container justifyContent="space-between">
                                <div className='d-flex justify-content-end align-items-center mt-3'>
                                    <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                                </div>
                                <div className='d-flex justify-content-end align-items-center mt-3'>
                                    <label className='me-2'>No. of Rows</label>
                                    <select
                                        label="Rows per page"
                                        value={selectedRecord || 20}
                                        onChange={(e) => {
                                            const value = Number(e.target.value);
                                            setShowRecord(value);
                                            setCurrentPage(1);
                                        }}
                                        sx={{ mr: 2 }}
                                    >
                                        {[5, 10, 20, 50].map((size) => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}
                                    </select>
                                </div>
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                {paginatedata && paginatedata.last_page > 0 && (
                                    <div className="pagination">
                                        {(() => {
                                        const totalPages = Math.max(1, paginatedata.last_page);
                                        const pages = [];

                                        const start = Math.max(2, currentPage - 2);
                                        const end = Math.min(totalPages - 1, currentPage + 2);

                                        // Always show page 1
                                        pages.push(
                                            <button
                                            key={1}
                                            onClick={() => handlePageChange(1)}
                                            className={currentPage === 1 ? 'active' : ''}
                                            >
                                            1
                                            </button>
                                        );

                                        // Ellipsis after page 1 if needed
                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis">...</span>);
                                        }

                                        // Middle pages
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                            <button
                                                key={i}
                                                onClick={() => handlePageChange(i)}
                                                className={currentPage === i ? 'active' : ''}
                                            >
                                                {i}
                                            </button>
                                            );
                                        }

                                        // Ellipsis before last page if needed
                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis">...</span>);
                                        }

                                        // Always show last page (if more than 1)
                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                onClick={() => handlePageChange(totalPages)}
                                                className={currentPage === totalPages ? 'active' : ''}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }

                                        return pages;
                                        })()}
                                    </div>
                                )}
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === paginatedata.last_page}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </Grid>
                            </>}
                    </>}
                </Box>
            </Grid>

            {/* Short Description modal */}
            <Modal size='lg' centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Short Description</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mb-3 wrap_textnotflow'>{modalData}</Modal.Body>
            </Modal>

            {/* Export modals: background-running + >10k email prompt */}
            <ExportDialogs
                exporting={exporting}
                prompt={prompt}
                onEmail={confirmEmail}
                onContinue={confirmContinue}
                onCancel={cancelPrompt}
                loaderSrc={require('../../../assets/pinkloader.gif')}
            />
        </div>
    </div>
  )
}

export default GroupTask